import Dexie from 'dexie';

const db = new Dexie("omniscan");

db.version(13).stores({
  projects: "id, client, code, name, type, description, photo",
  buildings: "id, projectId, code, name, description, photo",
  floors:"id, buildingId, code, displayCode, name, description, dwg, width, height",
  times:"id, sequence, hour, minute",
  workplaceTypes: "id, code, name, description, systemCode, multiOccupancy",
  activities: "id, code, name, description, index, color",
  workplaces: "id, code, name, description, surveyWorkplaceTypeId, svg, floorId",
  utilisation: "++id, spaceId, floorId, timestamp, observationHour, observationMinute, capacityUsed, activityId, occupiedVacantSol, processed, uploaded, reopened"
});

export default db;